export default __webpack_public_path__ + "img/45141ca072b7ea3929ba38373432786f.svg";